module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 p-10 text-center"
  }, [_c('div', {
    staticClass: "form-group input-group pull-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeIds),
      expression: "storeIds"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeIds = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v(_vm._s(store.label))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-group pull-right"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v("  ~  ")]), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "btn btn-success submit-btn btn-search",
    staticStyle: {
      "top": "-2px"
    },
    attrs: {
      "type": "button",
      "id": "brand-chart-search"
    },
    on: {
      "click": _vm.getChart
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 p-10"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日訂單數量與杯數比較")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "today-amount-compare"
    }
  })])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 p-10"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日訂單數量與總額比較")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "today-money-compare"
    }
  })])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 p-10"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日訂單平均金額")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "today-money-average"
    }
  })])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 p-10"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("當日會員數量")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "shopper-brief"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-876068b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Chart/Temp/BrandChart.vue
// module id = 2508
// module chunks = 1